import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { pairwise, startWith } from 'rxjs';
import { CoreService } from 'src/app/services/core/core.service';

@Component({
    selector: 'app-add-purchase-order-preview',
    templateUrl: './add-purchase-order-preview.component.html',
    styleUrls: ['./add-purchase-order-preview.component.scss'],
    standalone: false
})
export class AddPurchaseOrderPreviewComponent implements OnInit {
  @Input() model: any = {};
  @Input() form: any = {};
  @Output() callback = new EventEmitter<any>(true);
  @Input() addPurchaseOrderObject:any

  public vendorDetail: any = {};
  public vendorInfo: any = {};
  public vendorContact: any = {};


  constructor(
    public coreService: CoreService
  ) { }

  ngOnInit(): void {

    this.form.get('step01').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.vendorDetail = next?.vendorDetail;
      });

    this.form.get('step02').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.vendorInfo = next?.vendorInfo;
      });

    this.form.get('step03').valueChanges
      .pipe(startWith(null), pairwise())
      .subscribe(([prev, next]: [any, any]) => {
        this.vendorContact = next?.vendorContact;
      });

  }
}